import Dropzone from "dropzone";
import $ from "jquery";

// Disable Dropzone's auto-discovery
Dropzone.autoDiscover = false;

/**
 * Automatically initializes Dropzone instances for elements with the `data-dropzone` attribute.
 */
export function initializeDropzones(): void {
    $(() => {
        $("div[data-dropzone]").each(function () {
            const obj = $(this);
            initDropzone(obj.attr("id")!);
        });
    });
}

/**
 * Initializes a Dropzone instance for a specific element.
 * @param {string} id - The ID of the Dropzone element.
 * @returns {Dropzone} - The initialized Dropzone instance.
 */
export function initDropzone(id: string): Dropzone | undefined {
    const obj = $(`#${id}`);
    const url = obj.attr("data-url");
    const formId = obj.attr('data-form') ?? obj.closest('form').attr('ID');
    const divId = obj.attr('data-div');
    const multiple = obj.attr("data-multiple") === "true";
    const autoProcess = obj.attr("data-autoprocess") === "true";
    const maxSize = parseInt(obj.attr("data-maxsize") ?? "1024", 10); 
    // Senza "data-maxfiles", parseInt dava NaN e Dropzone non abilitava la selezione
    // multipla nel dialog. 
    const maxFilesAttr = obj.attr("data-maxfiles");
    const maxFiles = maxFilesAttr ? parseInt(maxFilesAttr, 10) : (multiple ? null as unknown as number : undefined); 
    const acceptedExtensions = obj.attr("data-acceptedextensions");
    const onsuccess = obj.attr("data-onsuccess");
    const message = obj.attr("data-defaultmessage") ?? "<i class='incore-mi-normal' style='font-size: 24px;'>photo_camera</i>";
    const capture = obj.attr('data-capture') ?? 'file';
    const addRemoveLinks = obj.attr('data-addremovelinks') === "true";
    const dictRemoveFile = obj.attr('data-dictremovefile');
    const parallelUploads = parseInt(obj.attr("data-paralleluploads") ?? "100", 10);

    return createDropzone(id, url, formId, divId, multiple, maxSize, maxFiles, acceptedExtensions, autoProcess, onsuccess, message, capture, addRemoveLinks, dictRemoveFile, parallelUploads);
}

/**
 * Creates and configures a Dropzone instance.
 * @param {string} id - The ID of the Dropzone element.
 * @param {string | null} url - The upload URL.
 * @param {string | null} formId - The ID of the form containing the Dropzone.
 * @param {string | null} divId - The ID of the div containing the Dropzone.
 * @param {boolean} multiple - Whether multiple files can be uploaded.
 * @param {number} maxSize - The maximum file size in MB.
 * @param {number | null} maxFiles - The maximum number of files.
 * @param {string | null} acceptedExtensions - The accepted file extensions.
 * @param {boolean} autoProcess - Whether to automatically process the queue.
 * @param {string | undefined} onsuccess - The success callback function name.
 * @param {string} message - The default Dropzone message.
 * @param {string} capture - The default Dropzone type of capture (default: file).
 * @param {number} parallelUploads - Quanti file partono per richiesta (default: 100). Con 1 ogni file ha la sua richiesta: utile per
 *                                   i limiti di dimensione del server e per caricare cartelle intere.
 * @returns {Dropzone | undefined} - The initialized Dropzone instance.
 */
export function createDropzone(
    id: string,
    url: string | undefined,
    formId: string | undefined,
    divId: string | undefined,
    multiple: boolean,
    maxSize: number,
    maxFiles: number | undefined,
    acceptedExtensions: string | undefined,
    autoProcess: boolean,
    onsuccess: string | undefined,
    message: string,
    capture: string,
    addRemoveLinks: boolean,
    dictRemoveFile: string | undefined,
    parallelUploads: number = 100
): Dropzone | undefined {
    let dropzone: Dropzone;

    if (divId) {
        var form = $("#" + divId);
        dropzone = new Dropzone("#" + id, {
            url: url,
            method: "post",
            uploadMultiple: multiple,
            maxFilesize: maxSize,
            paramName: "files",
            capture: capture,
            maxFiles: maxFiles,
            acceptedFiles: acceptedExtensions,
            autoProcessQueue: autoProcess,
            dictDefaultMessage: message,
            parallelUploads: parallelUploads,
            addRemoveLinks: addRemoveLinks,
            dictRemoveFile: dictRemoveFile

        });

        const getMessage = () => $(dropzone.element).find(".dz-default.dz-message");

         // Intercetta l'aggiunta di un file
        dropzone.on("addedfile", function (file) {
            getMessage().css('display', 'none');
        });

        // Scatta a ogni rimozione di file (evento corretto: "removedfile")
       dropzone.on("removedfile", () => {
            if (dropzone.files.length === 0) {
                getMessage().css("display", "");
            }
        });

        
        if(multiple){
            dropzone.on("sendingmultiple", function (files, response, formData) {
                preparaFormDropzone(files, response, formData, form, formId);
            });
        }
        else{
            dropzone.on("sending", function (file, response, formData) {
                preparaFormDropzone(file, response, formData, form, formId);
            });
        }
    }
    else if (url) {
        dropzone = new Dropzone(`#${id}`, {
            url: url,
            method: "post",
            uploadMultiple: multiple,
            maxFilesize: maxSize,
            paramName: "files",
            capture: capture,
            maxFiles: maxFiles,
            acceptedFiles: acceptedExtensions,
            autoProcessQueue: autoProcess,
            dictDefaultMessage: message,
            addRemoveLinks: addRemoveLinks,
            dictRemoveFile: dictRemoveFile
        });
    } else if (formId) {
        const form = $(`#${formId}`);
        const action = form.attr("action");
        const submit = form.find(":submit");

        dropzone = new Dropzone(`#${id}`, {
            url: action!,
            method: "post",
            uploadMultiple: multiple,
            maxFilesize: maxSize,
            paramName: "files",
            maxFiles: maxFiles,
            acceptedFiles: acceptedExtensions,
            autoProcessQueue: autoProcess,
            dictDefaultMessage: message,
            addRemoveLinks: addRemoveLinks,
            dictRemoveFile: dictRemoveFile,
            init: function () {
                const wrapperThis = this;
                $(submit).on("click", function (e) {
                    e.preventDefault();
                    wrapperThis.processQueue();
                });
            },
        });

        const getMessage = () => $(dropzone.element).find(".dz-default.dz-message");

         // Intercetta l'aggiunta di un file
        dropzone.on("addedfile", function (file) {
            getMessage().css('display', 'none');
        });

        // Scatta a ogni rimozione di file (evento corretto: "removedfile")
       dropzone.on("removedfile", () => {
            if (dropzone.files.length === 0) {
                getMessage().css("display", "");
            }
        });

        if(multiple){
            dropzone.on("sendingmultiple", function (files, response, formData) {
                preparaFormDropzone(files, response, formData, form, formId);
            });
        }
        else{
            dropzone.on("sending", function (file, response, formData) {
                preparaFormDropzone(file, response, formData, form, formId);
            });
        }
    } else {
        return undefined;
    }

    if (onsuccess) {
        dropzone.on("success", eval(onsuccess));
    }

    dropzone.on("complete", (file) => {
        dropzone.removeFile(file);
        $(".dz-default.dz-message").css("display", "unset");
    });

    return dropzone;
}

export function preparaFormDropzone(
    file: File | File[] | null,
    response: any,
    formData: FormData,
    form: JQuery<HTMLElement>,
    formId: string | undefined
): void {
    const formModel: Record<string, any> = {};

    $(form).find("input:not([type='submit']):not([name='__RequestVerificationToken']), select, textarea").each((i, v) => {
        const name = $(v).attr("name");
        if (name) {
            formModel[name] = $(v).val();
        }
    });

    // Prova prima nel form / div
    let tokenElement = $(form).find("[name='__RequestVerificationToken']").first();

    // Fallback: cerco nel form piu vicino
    if (tokenElement.length === 0) {
        tokenElement = $(`#${formId}`).find("[name='__RequestVerificationToken']").first();
    }

    // Fallback: cerco nella modale aperta e infine nella pagina
    if (tokenElement.length === 0) {
        tokenElement = $(".InCoreModal").find("[name='__RequestVerificationToken']").first();
    }
    if (tokenElement.length === 0) {
        tokenElement = $("[name='__RequestVerificationToken']").first();
    }

    const tokenName = tokenElement.attr("name");
    const tokenValue = tokenElement.val();

    if (tokenName && tokenValue !== undefined) {
        formData.append(tokenName, tokenValue.toString());
    }

    formData.append("modelStr", JSON.stringify(formModel));

    // Percorso relativo di ogni file, nello stesso ordine di invio: serve a ricreare le cartelle quando si carica una cartella intera
    // (fullPath lo imposta Dropzone al trascinamento di una cartella, webkitRelativePath la selezione con webkitdirectory)
    const files = Array.isArray(file) ? file : file ? [file] : [];
    formData.append("paths", JSON.stringify(files.map((f) => (f as any).fullPath || f.webkitRelativePath || "")));
}
